import {Injectable} from '@angular/core';
import {MatSidenav} from '@angular/material/sidenav';

@Injectable({
  providedIn: 'root'
})
export class CoreConfigurationService {
  public sidenav: MatSidenav;
  public showMenu: boolean;
  public isMobile: boolean;
  public navigatingInPopupContext: boolean;
  public referringUrl: string;
  public isOnline: boolean;
  public newVersionAvailable: boolean;

  public pwaEvent: any;

  public useFilterDialog(): boolean {
    return this.isMobile;
  }
}
